/* eslint-disable no-invalid-this */
/* eslint-disable require-jsdoc */
/* eslint-disable camelcase */
import TC_Wrapper from 'react-tag-commander'

const UNIQ_TAG_ID = '5477'

const containersIds: string[] = ['32']

interface TrackerOpts {
  tcReloadOnly: any
}

export default class TagCommander {
  public static instance: TagCommander
  private readonly tagId: string
  private loaded = false

  public static getInstance(): TagCommander {
    if (!TagCommander.instance) {
      TagCommander.instance = new TagCommander()
    }
    return this.instance
  }

  public static getTagId(): string {
    return UNIQ_TAG_ID
  }

  public static disabled(): boolean {
    return process.env.REACT_APP_TAGCOMMANDER_DISABLE === 'true'
  }

  public static withTrackerOpts(): TrackerOpts {
    return { tcReloadOnly: {} }
  }

  public tcWrapper: any

  constructor() {
    if (TagCommander.disabled()) {
      this.tagId = '0'
    } else {
      this.tcWrapper = TC_Wrapper.getInstance()
      this.tagId = TagCommander.getTagId()
      this!.init()
    }
  }

  public init = () => {
    if (this.loaded) {
      return
    }

    this.loaded = true

    this.enableDebug()
    this.trackRoutes()
    this.loadContainers()
  }

  private enableDebug = () => {
    if (
      process.env.REACT_APP_ENVIRONMENT !== 'production' &&
      process.env.REACT_APP_TAGCOMMANDER_DISABLE_LOGS !== 'true'
    ) {
      this.tcWrapper.setDebug(true)
    } else {
      this.tcWrapper.setDebug(false)
    }
  }

  private trackRoutes = () => {
    this.tcWrapper.trackRoutes()
  }

  private loadContainers = () => {
    containersIds.forEach((containerId) => {
      if (process.env.REACT_APP_ENVIRONMENT === 'production') {
        this.tcWrapper.addContainer(
            containerId,
            `https://cdn.tagcommander.com/${this.tagId}/tc_SeDomicilier_${containerId}.js`,
            'head'
        )
      } else {
        this.tcWrapper.addContainer(
            containerId,
            `https://cdn.tagcommander.com/${this.tagId}/uat/tc_SeDomicilier_${containerId}.js`,
            'head'
        )
      }
    })
  }
}
